import { useQuery } from '@tanstack/react-query';

export function useAssignableCoursesQuery({ queryOptions } = {}) {
  return useQuery({
    queryKey: ['assignableCourses'],
    queryFn: async () => {
      const response = await axios.get('/assignable_courses');

      return response.data;
    },
    ...queryOptions,
  });
}
